import React, { PureComponent } from 'react'
import './styles.scss'

class SectionSeparator extends PureComponent {
  render () {
    return (
      <hr className={'section-separator'}/>
    )
  }
}

export default SectionSeparator
